import React from "react";
import EditProfileForm from "../components/Forms/EditProfileForm";
import { Content, Container } from "../pages/Template";
import { setWindowTitle } from "../helpers";
import LogoutLink from "./Template/LogoutLink";

export class EditProfilePage extends React.Component {
    static paths = ["/app/profile"];
    static requiresAuth = true;

    componentDidMount() {
        setWindowTitle("اکاؤنٹ");
    }

    render() {
        return (
            <Content>
                <Container width="500px">
                    <EditProfileForm />
                    <LogoutLink />
                </Container>
            </Content>
        );
    }
}
